import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'
import Vuex from 'vuex'

import './assets/style.scss'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    loading: true,
    authenticated: false, 
    list: [], 
    currentPlayer: null
  }, 
  mutations: {
    AUTH_STATE_CHANGED: function(state, auth){
      state.authenticated = auth
    }, 
    SET_LIST: function(state, data){
      state.list = data.list
    }, 
    SET_CURRENT_PLAYER: function(state, player){
      state.currentPlayer = player
    }, 
    LOADING: function(state, loading){
      state.loading = loading
    }
  }, 
  actions: {
    fetchAuthState: async function(ctx){
      ctx.commit('LOADING', true)
      return (await fetch('api/login')).json().then(data => {
        ctx.commit('AUTH_STATE_CHANGED', data)
        ctx.commit('LOADING', false)
        return data
      })
    }, 
    login: async function(ctx, pwd){
      try {
        ctx.commit('LOADING', true)
        let status = await (await fetch('api/login', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({password: pwd})})).json()
        ctx.commit('AUTH_STATE_CHANGED', status.loggedIn)
        ctx.commit('LOADING', false)
      } catch (err) {
        ctx.commit('AUTH_STATE_CHANGED', false)
        ctx.commit('LOADING', false)
      }
    }, 
    fetchList: async function(ctx){
      let list = await (await fetch('api/list')).json(); 
      ctx.commit('SET_LIST', list)
    }, 
    currentPlayer: function(ctx, id){
      let player = ctx.state.list.find(function(p){ return p.id == id })
      ctx.commit('SET_CURRENT_PLAYER', player)
    }
  }
})

import Login from './components/Login.vue'
import List from './components/List.vue'
import Player from './components/Player.vue'

const routes = [
  {
    path: '/login', 
    component: Login
  },
  {
    path: '/list', 
    component: List
  }, 
  {
    path: '/player/:id', 
    component: Player, 
    props: true
  }
]

const router = new VueRouter({
  routes, 
  base: '/'
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
